module.exports = __webpack_public_path__ + "img/67b4fa7.svg";